import { EmptyTableResults } from '@/components/Table/styles';
import { TableType } from '@/components/Table/types/types';
import { BILLED_EVENTS_TABLE_CONFIG } from './const/const';
import { BilledEventTableRowType } from './helpers/helpers';
import { NoResults } from '@/components/NoResults/NoResults';
import NoItemsIcon from '@/images/NoItemsIcon.svg?react';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const BilledEventsTable = ({ items = [], isLoading }: TableType<BilledEventTableRowType>) => {
  const { isMobile } = useResponsiveDevice();
  const hasItems = !!items.length;
  const noItems = !hasItems && !isLoading;

  if (noItems) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoItemsIcon />} message='No billable events are recorded yet.' />
      </EmptyTableResults>
    );
  }

  return isMobile ? (
    <MobileTable config={BILLED_EVENTS_TABLE_CONFIG} items={items} isLoading={isLoading} />
  ) : (
    <DesktopTable config={BILLED_EVENTS_TABLE_CONFIG} items={items} isLoading={isLoading} isClickableRow={false} />
  );
};
